export default "__VITE_ASSET__6d43f217__"